export const dedicationFormMessages = {
  // Header
  title: 'Add a Dedication',
  subtitle:
    'Make this story even more special by adding an optional dedication',

  // Form
  dedicationLabel: 'Dedication',
  dedicationPlaceholder:
    'Dear little reader, we hope you enjoy this story and all the special memories it holds...',
  characterCount: (current: number, max: number) =>
    `${current}/${max} characters`,
} as const;
